"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Favourite = void 0;
const study_1 = require("./study");
class Favourite {
    constructor(study, dateAdded, properties = {}) {
        this.study = study;
        this.dateAdded = dateAdded;
        this.properties = properties;
    }
    setApplicationStatus(status) {
        this.properties.applicationStatus = status;
    }
    setAssessments(assessments) {
        this.properties.assessments = assessments;
    }
    setApplication(application) {
        if (application === null) {
            delete this.properties.application;
            return;
        }
        this.properties.application = application || undefined;
    }
    static create(studyId, dateAdded = new Date(), properties = {}) {
        return new Favourite(new study_1.Study(studyId), dateAdded, properties);
    }
}
exports.Favourite = Favourite;
